import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=7282a86c&scoped=true&"
import script from "./customization.vue?vue&type=script&lang=js&"
export * from "./customization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7282a86c",
  null
  
)

export default component.exports